/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ParameterValue } from "../simple-function-action-editor.component";
import { Event } from "app/models/event";
import { PropertyType } from "app/models/property-type";

@Component({
  selector: 'app-function-parameter-editor-string',
  templateUrl: './string-function-parameter-editor.component.html'
})
export class StringFunctionParameterEditorComponent {

  //Event Trigger used for the Rule
  @Input()
  set event(event: Event) {
    this._event = event;
    this.refreshOptions(true);
  }
  get event(): Event {
    return this._event;
  }
  _event: Event;

  //Parameter Value being shown / represented
  @Input()
  set parameterValue(parameterValue: ParameterValue) {
    this._parameterValue = parameterValue;
    this.showDynamicOptions = parameterValue != null && this.parameterValue.mValue != null && this.parameterValue.mValue.startsWith("${") && this.parameterValue.mValue.endsWith("}");
  }
  get parameterValue(): ParameterValue {
    return this._parameterValue;
  }
  _parameterValue: ParameterValue;

  @Output()
  valueChange = new EventEmitter<void>();

  //Flag indicating whether any information for the Component is being loaded
  loadingOptions = true;

  eventOptions: SelectOption[] = [];
  selectOptions: SelectOption[] = [];

  get stringValue(): string {
    return this.parameterValue == null? null : this.parameterValue.mValue;
  }
  set stringValue(value: string) {
    if (this.parameterValue != null) {
      this.parameterValue.mValue = value;
      this.valueChange.emit();
    }
  }

  get selectedOption(): SelectOption {
    if (this.parameterValue != null && this.parameterValue.mValue != null) {
      const rv = this.selectOptions.find(option => option.mValue == this.parameterValue.mValue);
      return rv? rv : null;
    }
    return null;
  }
  set selectedOption(option: SelectOption) {
    if (this.parameterValue != null) {
      this.parameterValue.mValue = option == null? null : option.mValue;
      this.valueChange.emit();
    }
  }


  showDynamicOptions = false;

  async refreshOptions(refreshEventOptions: boolean): Promise<void> {
    this.loadingOptions = true;

    if (refreshEventOptions) {
      await this.refreshEventOptions();
    }

    const options: SelectOption[] = [];
    options.push(...this.eventOptions);
    this.selectOptions = options;

    this.loadingOptions = false;
  }

  async refreshEventOptions(): Promise<void> {
    const options: SelectOption[] = [];
    if (this.event != null) {
      if (this.event.properties != null) {
        for (const eventProperty of this.event.properties) {
          if (eventProperty.type == PropertyType.STRING) {
            const option = new SelectOption();
            option.mValue = "${event." + eventProperty.property + "}";
            option.mDisplay = "FROM EVENT => " + eventProperty.name;
            options.push(option);
          }
        }
      }
    }
    this.eventOptions = options;
  }

}


class SelectOption {
  mValue: string;
  mDisplay: string;
}
